// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index-cls1___7b33f9fb160ba03e8f5{/*!*/}.index-cls2___ca2bbe874d6060b9260{flex-basis:220px;flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "index-cls1___7b33f9fb160ba03e8f5",
	"cls2": "index-cls2___ca2bbe874d6060b9260 index-cls1___7b33f9fb160ba03e8f5"
};
export default ___CSS_LOADER_EXPORT___;
